import { identityPoolId, userPoolId, appId, userPoolProvider } from '../constants/amazon'
import { CognitoUserPool, AuthenticationDetails, CognitoUser } from 'amazon-cognito-identity-js'

// Code samples: https://github.com/aws/amazon-cognito-identity-js

let cognitoUser = null

const removeRegion = (userIdWithRegion) => {
  const idx = userIdWithRegion.indexOf(":")
  return userIdWithRegion.substring(idx + 1)
}

export const AUTHENTICATE_COGNITO = 'AUTHENTICATE_COGNITO'
export function AuthenticateCognito(provider, token) {
  return dispatch => {
    const AWS = window.AWS
    const logins = {}
    logins[provider] = token
    AWS.config.credentials = new AWS.CognitoIdentityCredentials({
      IdentityPoolId: identityPoolId,
      Logins: logins
    })
    return new Promise((resolve, reject) => {
      AWS.config.credentials.get(err => {
        if (err) {
          reject(err)
        } else {
          const cognitoUserId = AWS.config.credentials.data.IdentityId
          dispatch({
            type: AUTHENTICATE_COGNITO,
            authenticated: true,
            userId: removeRegion(cognitoUserId)
          })
          resolve()
        }
      })
    })
  }
}

export const REGISTER_USER = 'REGISTER_USER'
export function RegisterUser(username, password) {
  return dispatch => {
    const poolData = {
      UserPoolId: userPoolId,
      ClientId: appId
    }
    var userPool = new CognitoUserPool(poolData)
    return new Promise((resolve, reject) => {
      userPool.signUp(username, password, [], null, function (err, result) {
        if (err) {
          reject(err)
          return
        }
        const cognitoUserId = result.user
        dispatch({
          type: REGISTER_USER,
          userId: cognitoUserId
        })
        resolve(cognitoUserId)
      })
    })
  }
}

export const AUTHENTICATE_USER = 'AUTHENTICATE_USER'
export function AuthenticateUser(username, password) {
  return dispatch => {
    return new Promise((resolve, reject) => {
      const AWS = window.AWS
      const authenticationDetails = new AuthenticationDetails({
        Username: username,
        Password: password,
      })
      const userPool = new CognitoUserPool({
        UserPoolId: userPoolId,
        ClientId: appId
      })
      const userData = {
        Username: username,
        Pool: userPool
      }
      cognitoUser = new CognitoUser(userData)
      cognitoUser.authenticateUser(authenticationDetails, {
        onSuccess: (result) => {
          const logins = {}
          logins[userPoolProvider] = result.getIdToken().getJwtToken()
          AWS.config.credentials = new AWS.CognitoIdentityCredentials({
            IdentityPoolId: identityPoolId,
            Logins: logins
          })
          AWS.config.credentials.refresh((error) => {
            if (error) {
              reject(error)
            } else {
              const cognitoUserId = AWS.config.credentials.data.IdentityId
              dispatch({
                type: AUTHENTICATE_COGNITO,
                authenticated: true,
                userId: removeRegion(cognitoUserId)
              })    
              resolve()
            }
          })
        },
        onFailure: (err) => {
          reject(err)
        }
      })
    })
  }
}

const AUTHENTICATE_LOGOUT = 'AUTHENTICATE_LOGOUT'
export function Logout () {
  const AWS = window.AWS
  const FB = window.FB
  return dispatch => {
    return new Promise((resolve, reject) => {
      if (cognitoUser && cognitoUser.globalSignOut) {
        // Username and password
        cognitoUser.globalSignOut({
          onSuccess: () => {
            dispatch({ type: AUTHENTICATE_LOGOUT })
            resolve() 
          }
        })
      } else if (AWS.config.credentials && AWS.config.credentials.clearCachedId) {
        // Facebook
        AWS.config.credentials.clearCachedId()
        if (FB && FB.logout) {
          FB.logout(response => { 
            dispatch({ type: AUTHENTICATE_LOGOUT })
            resolve() 
          })
        }
      }
    })
  }
}
